'use client';

// Component will be used on future task for complete register

import { useEffect } from 'react';
// import { usePathname, useRouter } from 'next/navigation';
// import { useStore } from 'zustand';

// import { useNavigation } from '@/hooks/navigation/use-navigation.hook';
import { resolveAuthenticatedUser } from '@/store/auth.store';
// import { AuthenticatedUser } from '@/types/auth-base.types';

// function customerHasDataPendencies(authenticatedUser?: AuthenticatedUser) {
//   if (!authenticatedUser) {
//     return false;
//   }

//   const { birthday, legalName } = authenticatedUser || {};
//   const { email } = authenticatedUser?.contact || {};
//   return !(birthday && legalName && email && authenticatedUser?.address?.city && authenticatedUser?.address?.state);
// }

export default function LoadUserComponent(): React.ReactNode {
  // const user = useStore(authStore, (state) => state.authenticatedUser) as AuthenticatedUser;
  // const [customerHasPendencies, setCustomerHasPendencies] = useState(false);

  useEffect(() => {
    resolveAuthenticatedUser();
  }, []);

  // useEffect(() => {
  //   const hasPendencies = customerHasDataPendencies(user);
  //   setCustomerHasPendencies(hasPendencies);
  // }, [user]);

  return <></>;
  // return customerHasPendencies ? <CheckPathForCustomerRedirectComponent user={user} /> : <></>;
}

// function CheckPathForCustomerRedirectComponent({ user }: { user: AuthenticatedUser }): React.ReactNode {
//   const router = useRouter();
//   const { buildLink } = useNavigation();
//   const path = usePathname();

//   useEffect(() => {
//     const hasPendencies = customerHasDataPendencies(user);
//     if (hasPendencies && path !== '/completar-cadastro') {
//       router.push(buildLink({ path: '/completar-cadastro' }));
//     }
//   }, [user, path, buildLink, router]);

//   return null;
// }
